<template>
  <div>
    <el-dialog
            :close-on-click-modal="false"
            :title="title"
            :visible.sync="show"
            top="10px"
            width="700px" >
      <div style="width: 100%; height: 100%;" v-loading="loading">
        <div class="w100 pr20 pt20 pb20 " style="overflow: auto;height: calc(100vh - 170px)">
          <el-form label-width="120px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
            <div class="cl-f">
                <el-form-item label="责任部门名称" prop="respDeptId" style="min-width: 250px;">
                  <TreeSelect size="small"
                              :data="departmentData"
                              clearable
                              v-if="show"
                              expandAll
                              ref="deptSingle"
                              :obj="mapKey"
                              checkStrictly
                              @getValue="setDeptSingleMenu">

                  </TreeSelect>

                </el-form-item>
            <el-form-item label="关联部门" prop="deptIds" style="min-width: 250px;">
              <TreeSelect size="small" :data="departmentData"
                          v-if="show"
                          clearable
                          multiple
                          expandAll
                          ref="deptDouble"
                          :obj="mapKey"
                          checkStrictly
                          @getValue="setDeptDoubleMenu"></TreeSelect>
            </el-form-item>

            <el-form-item label="权利说明" prop="rights" style="min-width: 250px;">

              <quillEditorCom v-model="form.rights"  />
            </el-form-item>

            <el-form-item label="责任说明" prop="responseblity" style="min-width: 250px;">
                <quillEditorCom v-model="form.responseblity" />
            </el-form-item>

                <el-form-item label="岗位名称" prop="roleIds" style="min-width: 250px;">
                  <el-select v-model="form.roleIds" multiple placeholder="请选择" class="w100">
                    <el-option
                            v-for="item in roleList"
                            :key="item.roleId"
                            :label="item.roleName"
                            :value="item.roleId">
                    </el-option>
                  </el-select>
                </el-form-item>

            <el-form-item label="提供的服务" prop="serveIds" style="min-width: 250px;">
              <div>
                <div class="el-select-serve" @click="serveSelect()">
                  <el-tag
                          :key="tag.serve_id"
                          v-for="tag in serveList"
                          closable
                          style="margin:0 3px"
                          type="info"
                          :disable-transitions="false"
                          @close="handleClose(tag)">
                    {{tag.server_name}}
                  </el-tag>

                </div>
                <el-input v-model="form.serveIds" style="display: none"></el-input>
              </div>

            </el-form-item>

                        <!--<el-col :span="12">-->
            <!--<el-form-item label="办理时效" prop="timeLimitType" style="min-width: 250px;">-->
              <!--<el-input v-model="form.timeLimitType" placeholder="请输入办理的时效信息"></el-input>-->
            <!--</el-form-item>-->
                        <!--</el-col>-->
            </div>
          </el-form>

        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
        <el-button @click="show = false">取 消</el-button>
      </div>

    </el-dialog>
    <select-serve ref="selectServeRef" @sureSelect="sureSelect"/>
  </div>
</template>

<script>
    import SelectServe from "@/components/SelectServe.vue";
    import TreeSelect from "@/components/TreeSelect.vue";
    import {getAllJobList} from '@/api/managementCenter/jobManage';
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    import {hallSaveOrUpdate} from '@/api/managementCenter/chargeManage';
    import quillEditorCom from '@/components/common/quillEditor.vue'
    export default {
        name: "AppDialog",
        components: {SelectServe,TreeSelect,quillEditorCom},
        props: [],
        data() {
            return {
                type:'',

                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                roleList:[],
                departmentData:[],
                show: false,
                loading: false,
                title: "",
                form: {
                    id: "",
                    respDeptId: "",
                    deptIds: [],
                    roleIds:[],
                    rights:"",
                    responseblity: "",
                    serveIds:'',
                    timeLimitType:""
                },
                doubleSelect:[],
                serveList:[],
                rules: {
                    respDeptId: [
                        { required: true, message: "请选择责任部门", trigger: "blur" }
                    ],
                    deptIds: [
                        { required: true, message: "请选择关联部门", trigger: "blur" }
                    ],
                    roleIds: [
                        { required: true, message: "请选择岗位名称", trigger: "blur" }
                    ],
                    rights: [
                        { required: true, message: "请输入权利名称", trigger: "blur" }
                    ],
                    responseblity: [
                        { required: true, message: "请输入责任名称", trigger: "blur" }
                    ],
                    serveIds: [
                        { required: true, message: "请选择提供服务", trigger: "blur" }
                    ],
                    timeLimitType: [
                        { required: true, message: "请输入时效", trigger: "blur" }
                    ]
                }
            };
        },
        computed: {

        },
        methods: {
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }
                        if( this.type=='edit'){
                            this.$nextTick(()=>{
                                // 编辑时部门回显
                                this.$refs.deptSingle.setKey(this.form.respDeptId)
                                this.$refs.deptDouble.setKeys(this.doubleSelect)
                            })
                        }

                    }
                }).catch(err=>{

                })
            },
            getAllJobListFn(){
                getAllJobList().then(({data})=>{
                    if(data.code == 0){
                        this.roleList = data.data.map(i=>{
                            return {
                                roleName:i.postName,
                                roleId:i.postId+''
                            }
                        })
                    }
                }).catch(err=>{

                })

            },
            setDeptSingleMenu(key,data){//获取子组件值
                this.form.respDeptId = data.id;
            },
            setDeptDoubleMenu(key,data){//获取子组件值
                this.doubleSelect = data.map(item=>item.id)
            },



            sureSelect(data){
                this.serveList = data
            },

            serveSelect(){
                this.$refs.selectServeRef.openDialog(this.serveList)
            },
            handleClose(tag){
                this.serveList =this.serveList.filter(item=>{
                    return item.serve_id!=tag.serve_id
                })
            },




            // 显示弹框
            dialogShow (type,data) {
                this.type=type
                // 重置表单、显示弹框
                this.show = true;
                this.$nextTick(function(){
                    this.$refs["ruleForm"].resetFields();

                    switch (type) {
                        case 'add' :
                            this.title = "新增权责"
                            this.form={
                                id: "",
                                respDeptId: "",
                                deptIds: [],
                                roleIds:[],
                                rights:"",
                                responseblity: "",
                                serveIds:'',
                                timeLimitType:""
                            };
                            break;
                        case 'edit' :
                            this.title = "编辑权责"
                            this.form={
                                id: data.id,
                                respDeptId: data.resp_dept_id,
                                deptIds:[],
                                roleIds:[],
                                rights:data.rights,
                                responseblity: data.responseblity,
                                serveIds:'',
                                timeLimitType:data.timeLimitType
                            };
                            this.doubleSelect = data.depts.map(i=>i.id+''),
                            this.form.roleIds = data.roles.map(i=>i.id+'')
                            this.serveList=data.serves.map(i=>{
                                return {
                                    serve_id:i.id,
                                    server_name:i.name
                                }
                            })

                            break;
                    }

                });
            },
            saveOrUpdate(){
                this.loading = true;
                const params={
                    ...this.form,
                    serveIds:this.serveList.map(i=>i.serve_id),
                    deptIds:this.doubleSelect

                }
                hallSaveOrUpdate(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "保存成功!" );
                        this.show=false
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning(  "保存失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                this.form.deptIds = this.doubleSelect.length>0?'true':""
                this.form.serveIds = this.serveList.length>0?'true':""

                this.$refs[formName].validate((valid) => {

                    if (valid) {
                       this.saveOrUpdate()
                    } else {
                        return false;
                    }
                });
            }
        },
        watch: {

            show(value){
                if(!value){
                    this.serveList=[];
                    this.doubleSelect = []
                }else{
                    // 打开弹框时，获取岗位和角色数据
                    this.getDeptTreeData()
                    this.getAllJobListFn()
                }

            }
        },
        filters: {}
    };
</script>

<style scoped>

  .el-select-serve{
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    min-height: 50px;
    padding: 8px;
    cursor: pointer;
    max-height: 200px;
    overflow: auto;
  }
/deep/.quill-editor{
  height: auto!important;
}
  /deep/.ql-container{
    min-height: 120px!important;
  }
  /deep/.ql-toolbar.ql-snow{
    padding: 0!important;
  }
</style>

